import React from 'react';
import {Layout, Flex, Button, Diary, Breadcrumbs} from 'components';
import {config} from 'helpers';

export function EveningRoutine() {
  return (
    <>
      <Layout.Header>
        <Flex className="justified">
          <div>
            <Breadcrumbs>
              {config.eveningRoutine}
              <b>Daily Reflections</b>
            </Breadcrumbs>
            <p className="small-spacing">Look back and reflect on your day by reviewing the following questions.</p>
          </div>
          <Button className={['primary', 'small']} to="./plan/" rightIcon="arrow-right">Next</Button>
        </Flex>
      </Layout.Header>
      <Diary.CheckIn subject="Reflections" type="reflections" next="./plan/">
        <h3>My Journal</h3>
      </Diary.CheckIn>
    </>
  );
}
